export default __webpack_public_path__ + "assets/check_white.ad6ac64e.svg";